module.exports = __webpack_public_path__ + "img/M55CNCshow-1.b86b21e7.jpg";